<!--
 Copyright 2022 by DomX Private Company

 All rights reserved,
 also regarding any disposal, exploitation, reproduction,
 editing, distribution, as well as in the event of
 applications for industrial property rights.

 This software contains proprietary and confidential
 information of DomX Private Company.
 The disclosure of confidential information without
 express authorization is prohibited.

 This software may include Open Source Software.
 As far as Open Source Software is included,
 your rights for the respective Open Source Software
 components are governed by the applicable
 Open Source Software licenses.
-->

<template class="fill-height">
  <v-overlay :value="modalName">
    <component
      :is="modalName"
      :payload="modalPayload"/>
  </v-overlay>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import AddInstallationAddressModal from './Modals/Installations/AddInstallationAddressModal.vue'

import { commonModule } from '@/store/modules/store-accessor'

@Component({
  components: {
    AddInstallationAddressModal,
  }
})
export default class TheSecondModal extends Vue {
  get modalName () {
    return commonModule.secondaryModal.name
  }

  get modalPayload () {
    return commonModule.secondaryModal.payload
  }
};
</script>  